import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ONotification = _resolveComponent("ONotification")!

  return (_openBlock(), _createBlock(_component_ONotification, {
    closable: _ctx.closable,
    rootClass: "base-message",
    class: _normalizeClass(`base-message--${_ctx.variant}`)
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3
  }, 8, ["closable", "class"]))
}